import React, { useState } from 'react';
import moment from 'moment';
import { Modal } from '@/components/custom/modal/modal';

// Aviso temporário de suporte, exibido para todos os perfis na home até a data
// de expiração abaixo. Remover este componente (e sua montagem em Dashboard)
// quando o aviso não for mais necessário.
const SUPPORT_POPUP_EXPIRATION_DATE = '2026-08-31';
const SUPPORT_POPUP_APPS = ['canaleducacao', 'maiseducacao'];

// Usadas para calcular a largura máxima sem nunca deixar a altura estourar o viewport
const IMAGE_ASPECT_RATIO = 221 / 412;
const IMAGE_MAX_WIDTH_PX = 464;

export default function SupportPopupModal() {
  const appName = process.env.REACT_APP_NAME;
  const isAllowedApp = SUPPORT_POPUP_APPS.includes(appName);
  const alreadyDismissed = localStorage.getItem('supportPopupDismissed') === 'true';
  const [show, setShow] = useState(() => isAllowedApp && !alreadyDismissed && moment().isSameOrBefore(SUPPORT_POPUP_EXPIRATION_DATE, 'day'));

  if (!isAllowedApp) return null;

  const handleClose = () => {
    localStorage.setItem('supportPopupDismissed', 'true');
    setShow(false);
  };

  return (
    <Modal
      show={show}
      onClose={handleClose}
      contentClassName="p-0 w-fit"
    >
      <img
        src="https://canaleducacao.s3.us-west-2.amazonaws.com/popup-suporte.png"
        alt="Aviso de suporte"
        className="block h-auto rounded-md"
        style={{ width: `min(${IMAGE_MAX_WIDTH_PX}px, 90vw, calc(60vh * ${IMAGE_ASPECT_RATIO}))` }}
      />
    </Modal>
  );
}
